export default __webpack_public_path__ + "images/florist-icon.1f875a516c708ee016b3df7144a779f4.svg";